import { useState } from 'react'
import { message } from 'antd'
import { CreateProcedureInput, Procedure } from '../types'

interface UseProcedureCreateReturn {
  createProcedure: (input: CreateProcedureInput, residentId: string) => Promise<void>
  isCreating: boolean
}

export const useProcedureCreate = (onSuccess?: () => void): UseProcedureCreateReturn => {
  const [isCreating, setIsCreating] = useState(false)

  const createProcedure = async (input: CreateProcedureInput, residentId: string): Promise<void> => {
    setIsCreating(true)

    // Simulate API call
    return new Promise((resolve) => {
      setTimeout(() => {
        const newProcedure: Procedure = {
          _id: Date.now().toString(),
          home: 'home123',
          resident: residentId,
          title: input.title,
          description: input.description,
          procedureDate: input.procedureDate,
          procedureTime: input.procedureTime,
          status: 'active',
          createdBy: { _id: 'currentUser', name: 'Current User' },
          createdAt: new Date().toISOString()
        }

        message.success('Procedure created successfully')
        setIsCreating(false)

        if (onSuccess) {
          onSuccess()
        }

        resolve()
      }, 500)
    })
  }

  return {
    createProcedure,
    isCreating
  }
}
